
export const DATA_OPERATIONS = [
    {id: 'OP01', title: 'Narušení drnu', mj: 'm2'},
    {id: 'OP02', title: 'Stržení drnu', mj: 'm2'},
    {id: 'OP03', title: 'Sejmutí ornice', mj: 'm2'},
    {id: 'OP04', title: 'Zemní práce', mj: 'm2'},
    {id: 'OP05', title: 'Základy', mj: 'm2'},
    {id: 'OP06', title: 'Zdivo', mj: 'm3'},
    {id: 'OP07', title: 'Kámen', mj: 'm3'},
    {id: 'OP08', title: 'Uložení sypaniny', mj: 'm2'},
    {id: 'OP09', title: 'Travnaté aprotierozní průlehy a meze', mj: 'm2'},
    {id: 'OP10', title: 'Zatravnění', mj: 'm2'},
    {id: 'OP11', title: 'Výsadba keřů', mj: 'ks'},
    {id: 'OP12', title: 'Následná péče o výsadbu keřů', mj: 'ks'},
    {id: 'OP13', title: 'Výsadba stromů', mj: 'ks'},
    {id: 'OP14', title: 'Následná péče o výsadbu stromů', mj: 'ks'},
];

export const DATA_MODIFICATIONS = [
    {id: 'MB01', title: 'Zídka', opId: ['OP01','OP02','OP03','OP04','OP05','OP06']},
    {id: 'MB02', title: 'Pás kamení', opId: ['OP01','OP02','OP07']},
    {id: 'MB03', title: 'Val', opId: ['OP01','OP02','OP08','OP07']},
    {id: 'MB04', title: 'Svah', opId: ['OP09']},
    {id: 'MV01', title: 'Travní kryt', opId: ['OP10']},
    {id: 'MV02', title: 'Výsadba keřů', opId: ['OP11','OP12']},
    {id: 'MV03', title: 'Výsadba stromů', opId: ['OP13','OP14']},
];

export const DEFAULT_PRICELIST = {
    title: 'Výchozí ceník prací a materiálu',
    items: [
        {id: '1', opId: 'OP01', title: 'Narušení drnu strojní', price: 0.80},
        {id: '2', opId: 'OP01', title: 'Narušení drnu ruční', price: 10.00},

        {id: '3', opId: 'OP02', title: 'Stržení drnu strojní', price: 30.00},
        {id: '4', opId: 'OP02', title: 'Stržení drnu ruční', price: 80.00},

        {id: '5', opId: 'OP03', title: 'Sejmutí ornice (hloubka 20cm), naložení, odvoz a uložení', price: 55.90},

        {id: '6', opId: 'OP04', title: 'Hloubení nezapaž. rýh (šířka 60cm, hloubka 100cm) v hornině 1-4', price: 622.00},
        {id: '7', opId: 'OP04', title: 'Hloubení nezapaž. rýh (šířka 60cm, hloubka 100cm) v hornině 5-7', price: 2025.00},
        {id: '8', opId: 'OP04', title: 'Hloubení zapaž. rýh (šířka 60cm, hloubka 100cm) v hornině 1-4', price: 1606.00},
        {id: '9', opId: 'OP04', title: 'Hloubení zapaž. rýh (šířka 60cm, hloubka 100cm) v hornině 5-7', price: 5265.00},
        {id: '10', opId: 'OP04', title: 'Hloubená vykopávka pod základy v hornině 3 (hloubka 100cm)', price: 5265.00},

        {id: '11', opId: 'OP05', title: 'Základový pas z betonu C 8/10, vč. bednění, štěrkopískový podklad 10 cm (hloubka 100cm)', price: 5905.00},
        {id: '12', opId: 'OP05', title: 'Základová zeď z betonu C 8/10 tloušťky 30 cm  bednění, štěrkopískový podklad 10 cm', price: 2835.00},
        {id: '13', opId: 'OP05', title: 'Základové pasy z lom. kamene na MC 10 (hloubka 100cm)', price: 5575.00},

        {id: '14', opId: 'OP06', title: 'Zdivo lícové cihelné spárované', price: 21700.00},
        {id: '15', opId: 'OP06', title: 'Zdivo z kamene, lícované, spárované', price: 7070.00},
        {id: '16', opId: 'OP06', title: 'Zídka z kamene na sucho ve strži, doprava do 10 m', price: 4030.00},

        {id: '17', opId: 'OP07', title: 'Kámen lomový upravený tř 1 kyklopský', price: 6905.00},
        {id: '18', opId: 'OP07', title: 'Břidlice zdicí kámen přírodní - tříděný', price: 8120.00},
        {id: '19', opId: 'OP07', title: 'Břidlice zdicí kámen přírodní - netříděný  volně loženo', price: 1395.00},
        {id: '20', opId: 'OP07', title: 'Zídka z kamene na sucho ve strži, doprava do 10 m', price: 4030.00},

        {id: '21', opId: 'OP08', title: 'Uložení sypaniny vrstva do 60 cm', price: 95.10},
        {id: '22', opId: 'OP08', title: 'Ulozeni sypaniny vrstva přes 60 do 100 cm', price: 82.50},
        {id: '23', opId: 'OP08', title: 'Ulozeni sypaniny vrstva přes 100 do 150 cm', price: 70.80},

        {id: '24', opId: 'OP09', title: 'Tvorba travnatých protierozních průlehů a mezí s terénními úpravami', price: 90.00},

        {id: '25', opId: 'OP10', title: 'Zatravnění nebo obnova bez kříženců', price: 1.70},
        {id: '26', opId: 'OP10', title: 'Zatravnění nebo obnova obohacenou směsí', price: 3.30},
        {id: '27', opId: 'OP10', title: 'Zatravnění regionální směsí', price: 6.50},
        {id: '28', opId: 'OP10', title: 'Zatravnění zeleným senem', price: 2.50},

        {id: '29', opId: 'OP11', title: 'Výsadba nízkých keřů včetně půdopokryvných do 20 cm', price: 145.00},
        {id: '30', opId: 'OP11', title: 'Výsadba listnatého keře - kontejnerovaný, vel. 20 - 40 cm', price: 200.00},
        {id: '31', opId: 'OP11', title: 'Výsadba listnatého keře - kontejnerovaný, vel. 40 cm - 60 cm', price: 320.00},
        {id: '32', opId: 'OP11', title: 'Výsadba listnatého keře - kontejnerovaný, vel. 60 cm - 100 cm', price: 400.00},
        {id: '33', opId: 'OP11', title: 'Výsadba listnatého keře - kontejnerovaný, vel. nad 100 cm', price: 550.00},
        {id: '34', opId: 'OP11', title: 'Výsadba listnatého keře - prostokořenný, vel. do 60 cm', price: 150.00},
        {id: '35', opId: 'OP11', title: 'Výsadba listnatého keře - prostokořenný, vel. nad 60 cm', price: 200.00},

        {id: '36', opId: 'OP12', title: 'Roční následná péče o jednotlivé solitérní keře', price: 115.00},

        {id: '37', opId: 'OP13', title: 'Výsadba ovocného špičáku', price: 950.00},
        {id: '38', opId: 'OP13', title: 'Výsadba ovocného rozvětveného polokmenu', price: 1400.00},
        {id: '39', opId: 'OP13', title: 'Výsadba ovocného rozvětveného vysokokmenu', price: 1800.00},
        {id: '40', opId: 'OP13', title: 'Výsadba listnatého špičáku', price: 800.00},
        {id: '41', opId: 'OP13', title: 'Výsadba listnatého odrostku do 120 cm', price: 900.00},
        {id: '42', opId: 'OP13', title: 'Výsadba listnatého odrostku 121 - 250 cm', price: 1350.00},
        {id: '43', opId: 'OP13', title: 'Výsadba listnatého stromu, ok 6 - 8 cm; rozvětvený, prostokořenný', price: 1700.00},
        {id: '44', opId: 'OP13', title: 'Výsadba listnatého stromu, ok 6 - 8 cm; rozvětvený, s balem', price: 2500.00},
        {id: '45', opId: 'OP13', title: 'Výsadba listnatého stromu, ok 8 -10 cm; rozvětvený, s balem', price: 2850.00},
        {id: '46', opId: 'OP13', title: 'Výsadba listnatého stromu, ok 10 - 12 cm; rozvětvený, s balem', price: 3300.00},
        {id: '47', opId: 'OP13', title: 'Výsadba listnatého stromu, ok 12 -14 cm (alejový strom); s balem', price: 4900.00},
        {id: '48', opId: 'OP13', title: 'Výsadba listnatého stromu, ok 14 -16 cm (alejový strom); s balem', price: 6600.00},
        {id: '49', opId: 'OP13', title: 'Výsadba listnatého stromu, ok nad 16 cm (alejový strom); s balem', price: 9100.00},
        {id: '50', opId: 'OP13', title: 'Výsadba půdokryvného jehličnanu do 40 cm', price: 330.00},
        {id: '51', opId: 'OP13', title: 'Výsadba jehličnanu 40 - 60 cm', price: 570.00},
        {id: '52', opId: 'OP13', title: 'Výsadba jehličnanu 60 - 80 cm', price: 900.00},
        {id: '53', opId: 'OP13', title: 'Výsadba jehličnanu 80 - 100 cm', price: 1650.00},
        {id: '54', opId: 'OP13', title: 'Výsadba jehličnanu 100 cm a více', price: 3850.00},

        {id: '55', opId: 'OP14', title: 'Roční následná péče o jednotlivé stromy', price: 600.00},
    ]
};
